
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Eye } from "lucide-react";
import ManualSelectionTab from "./ManualSelectionTab";
import AutoSelectionTab from "./AutoSelectionTab";

const QuestionsTab = ({
  selectedQuestions,
  setShowSelectedQuestions,
  questionFilters,
  setQuestionFilters,
  questionPage,
  setQuestionPage,
  questionsData,
  questionsLoading,
  categoriesData,
  handleQuestionToggle,
  getSubCategories,
  newAutoSelection,
  setNewAutoSelection,
  autoSelections,
  setAutoSelections,
  handleAutoSelectionAdd,
  handleAutoSelectionRemove,
  handleAutoSelectQuestions,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Question Management</h3>
        <div className="flex items-center gap-2">
          <Badge variant="outline" className="ml-auto bg-green-100 text-green-700">
            {selectedQuestions.length} questions selected
          </Badge>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => setShowSelectedQuestions(true)}
          >
            <Eye className="h-4 w-4 mr-1" />
            View Selected
          </Button>
        </div>
      </div>

      <Tabs defaultValue="manual" className="w-full">
        <TabsList>
          <TabsTrigger value="manual">Manual Selection</TabsTrigger>
          <TabsTrigger value="auto">Auto Selection</TabsTrigger>
        </TabsList>

        <TabsContent value="manual" className="space-y-4">
          <ManualSelectionTab
            questionFilters={questionFilters}
            setQuestionFilters={setQuestionFilters}
            questionPage={questionPage}
            setQuestionPage={setQuestionPage}
            questionsData={questionsData}
            questionsLoading={questionsLoading}
            categoriesData={categoriesData}
            selectedQuestions={selectedQuestions}
            handleQuestionToggle={handleQuestionToggle}
            getSubCategories={getSubCategories}
          />
        </TabsContent>

        <TabsContent value="auto" className="space-y-4">
          <AutoSelectionTab
            newAutoSelection={newAutoSelection}
            setNewAutoSelection={setNewAutoSelection}
            autoSelections={autoSelections}
            setAutoSelections={setAutoSelections}
            categoriesData={categoriesData}
            getSubCategories={getSubCategories}
            handleAutoSelectionAdd={handleAutoSelectionAdd}
            handleAutoSelectionRemove={handleAutoSelectionRemove}
            handleAutoSelectQuestions={handleAutoSelectQuestions}
            questionFilters={questionFilters}
            setQuestionFilters={setQuestionFilters}
            questionPage={questionPage}
            setQuestionPage={setQuestionPage}
            questionsData={questionsData}
            questionsLoading={questionsLoading}
            selectedQuestions={selectedQuestions}
            handleQuestionToggle={handleQuestionToggle}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default QuestionsTab;